import promiseClient from 'hub-http/adapters/promiseClient';
import { environmentUrl, hubletApi } from 'hub-http/middlewares/core';
import * as core from 'hub-http/middlewares/core';
// @ts-expect-error Untyped module
import * as debug from 'hub-http/middlewares/debug';
import { createStack } from 'hub-http';
import noAuthClient from 'hub-http/clients/noAuthApiClient';
import { getHubletAndEnvOverrides } from '../utils/urls';
import Env from 'enviro';
const hostname = window.location.hostname;
const subdomainParts = hostname.split('.');
const subdomain = subdomainParts[0];
const {
  hublet: customDomainHubletOverride,
  env: customDomainEnvOverride
} = await getHubletAndEnvOverrides(hostname);
if (customDomainEnvOverride) {
  Env.set('ENV', customDomainEnvOverride);
}
const paymentsApi = environmentUrl(hubletApi('payments', 'hubspot', customDomainHubletOverride, true));
const paymentsStack = createStack(core.jsonBody, core.httpsOnly, core.withQuery, debug.rewriteUrl, debug.enableFailureInjection, core.reportOptionsError, core.validateStatus, core.jsonResponse, paymentsApi);
export const paymentsClient = subdomain.includes('app') ? noAuthClient : promiseClient(paymentsStack);